module.exports = __webpack_public_path__ + "static/media/csm-thumbsup.0523e81f.svg";